import { ControlSize } from 'types/src/controls'
import { FavIcon, Wrapper } from './style'

type Props = {
    className?: string
    size: ControlSize
    url: string
}

export default ({ className, size, url }: Props) => {
    const iconUrl = url ? `https://www.google.com/s2/favicons?domain=${url}&sz=128` : ''

    return (
        <Wrapper className={className}>
            <FavIcon $size={size} alt="" src={iconUrl} />
        </Wrapper>
    )
}
